import type { BackendCallStatus } from '~/utils/interface/call';

export const CALLEE_BUSY_MESSAGE_CODES = new Set([
  'DEVICE_BUSY',
  'CALLEE_BUSY',
  'TARGET_BUSY',
  'DEVICE_IN_CALL',
  'USER_BUSY',
  'BUSY',
  'DEVICE_IS_BUSY',
  'CALLEE_DEVICE_BUSY',
]);

export const CALLER_ACTIVE_STATUSES = [
  'initiating',
  'pending',
  'accepted',
  'calling',
  'oncall',
] as const;

export function isCallerWebBusy(callStatus: string, isActiveCallVisible: boolean): boolean {
  return (
    isActiveCallVisible ||
    (CALLER_ACTIVE_STATUSES as readonly string[]).includes(callStatus)
  );
}

export function isCalleeDeviceBusy(input: {
  messageCode?: string | null;
  message?: string | null;
  status?: string | null;
  httpStatus?: number;
}): boolean {
  const code = (input.messageCode ?? '').trim().toUpperCase();
  if (code) {
    if (CALLEE_BUSY_MESSAGE_CODES.has(code)) return true;
    if (code.includes('DEVICE_BUSY') || code.endsWith('_BUSY') || code === 'BUSY') return true;
  }

  const status = (input.status ?? '').trim().toLowerCase();
  if (status === 'busy' || status === 'device_busy') return true;

  if (input.httpStatus === 409) return true;

  const msg = (input.message ?? '').trim();
  if (
    /busy|đang bận|đang trong cuộc gọi|đang nghe máy|in another call|device is busy|cannot receive call|không thể nhận cuộc gọi/i.test(
      msg
    )
  ) {
    return true;
  }

  return false;
}

export function isPollStatusCalleeBusy(
  status: BackendCallStatus,
  extras?: { messageCode?: string | null; message?: string | null }
): boolean {
  if (status === 'busy') return true;
  if (status !== 'rejected') return false;
  return isCalleeDeviceBusy({
    messageCode: extras?.messageCode,
    message: extras?.message,
    status: extras?.messageCode ?? 'rejected',
  });
}
